import React from "react";
import PropTypes from "prop-types";
import cn from "clsx";
import {
    BoxIconWrap,
    BoxIconWrapGrey,
    BoxIconMarker,
    BoxIconInfo,
    BoxIconHeading,
    BoxIconTitle,
    BoxIconDesc,
} from "./style";
import { Row, Col } from "@ui/wrapper";

import Image from "@ui/image";

const BoxIcon = ({
    icon,
    title,
    index,
    desc,
    images,
    heading,
    className,
    layout,
    ...restProps
}) => {
    if (index % 2 === 1) {
        return (
            <BoxIconWrap className={cn("box-icon", className)} {...restProps}>
                {icon && (
                    <BoxIconMarker $layout={layout}>
                        <i className={icon}></i>
                    </BoxIconMarker>
                )}
                {(title || desc || heading) && (
                    <BoxIconInfo>
                        <Row>
                            <Col>
                                {heading && (
                                    <BoxIconHeading $layout={layout}>
                                        {heading}
                                    </BoxIconHeading>
                                )}
                                {title && (
                                    <BoxIconTitle $layout={layout}>
                                        {title}
                                    </BoxIconTitle>
                                )}
                                {desc && <BoxIconDesc>{desc}</BoxIconDesc>}
                            </Col>
                            <Col
                                lg={{ span: 6, order: 2 }}
                                xs={{ span: 12, order: 2 }}
                            >
                                {images && (
                                    <Image
                                        src={images[0].src}
                                        alt={images[0].alt || title}
                                    />
                                )}
                            </Col>
                        </Row>
                    </BoxIconInfo>
                )}
            </BoxIconWrap>
        );
    } else {
        return (
            <BoxIconWrapGrey
                className={cn("box-icon", className)}
                {...restProps}
            >
                {icon && (
                    <BoxIconMarker $layout={layout}>
                        <i className={icon}></i>
                    </BoxIconMarker>
                )}
                {(title || desc || heading) && (
                    <BoxIconInfo>
                        <Row>
                            <Col>
                                {heading && (
                                    <BoxIconHeading $layout={layout}>
                                        {heading}
                                    </BoxIconHeading>
                                )}
                                {title && (
                                    <BoxIconTitle $layout={layout}>
                                        {title}
                                    </BoxIconTitle>
                                )}
                                {desc && <BoxIconDesc>{desc}</BoxIconDesc>}
                            </Col>
                            <Col
                                lg={{ span: 6, order: 2 }}
                                xs={{ span: 12, order: 2 }}
                            >
                                {images && (
                                    <Image
                                        src={images[0].src}
                                        alt={images[0].alt || title}
                                    />
                                )}
                            </Col>
                        </Row>
                    </BoxIconInfo>
                )}
            </BoxIconWrapGrey>
        );
    }
};

BoxIcon.propTypes = {
    icon: PropTypes.string,
    title: PropTypes.string,
    desc: PropTypes.string,
    heading: PropTypes.string,
    className: PropTypes.string,
    layout: PropTypes.number,
};

export default BoxIcon;
